import React, { Fragment, useState } from "react";
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
// import Paper from '@mui/material/Paper';
//import Logo from "../images/logo-bluetext.png"
import Box from '@mui/material/Box';
import { GetAccessToken, fetcher } from "../components/Dashboard/Utilities";
import useSWR from 'swr';
import LoadingOverlay from "react-loading-overlay";
import DarkBackground from "../components/Widgets/TransparentLoadingDisplay"
// import { InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
// import { Controller } from "react-hook-form";
// import FormControl from '@mui/material/FormControl';
// import { useForm } from 'react-hook-form';
// import { yupResolver } from '@hookform/resolvers/yup';
// import * as Yup from 'yup';
import NativeSelect from "@material-ui/core/NativeSelect";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import { useParams } from "react-router-dom";
import { InputLabel } from '@mui/material';
import { is } from "date-fns/locale";



export default function PersonalInformationSharing() {

    let { tenantIdent } = useParams();


    const Print = () => {
        //console.log('print');  
        let printContents = document.getElementById('printablediv').innerHTML;
        let originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload(false);
    }


    const [accessToken, setAccessToken] = useState(false);
    const [reportDescription, setReportDescription] = useState('');


    const [selectedGrade, setSelectedGrade] = React.useState('0');
    const [selectedGradeName, setSelectedGradeName] = React.useState('');
    const [gradeList, setGradeList] = React.useState();
    const [reportData, setReportData] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(true);

    var gradeLevelUrl = 'reports/getGradeLevelsUnAuth';
    if (tenantIdent !== undefined) {

        var gradeLevelUrl = 'reports/getGradeLevelsUnAuth?tenantCode=' + tenantIdent;
    }
    else {
        GetAccessToken(setAccessToken, false);
    }
    var error = false;

    if (gradeList === undefined) {
        var result = fetch(gradeLevelUrl,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },

            }
        ).then(data => data.json()).then(
            (data) => {
                setGradeList(data);

                //console.log(data);
                setIsLoading(false);

            },
            (error) => {
                // setLoading(false);
                //setError(error);
            }
        );
    }
    if (isLoading)
        if (error) return <div>failed to load</div>
    if (isLoading) {
        return (

            <DarkBackground >
                <LoadingOverlay
                    active={true}

                    spinner={true}
                    text="Loading..."
                >
                </LoadingOverlay>
            </DarkBackground>

        )
    }

    async function FetchReportData(grade, accessToken) {

        //var accessTokenbearer = 'Bearer ' + accessToken;
        //var token = accessToken;
        //console.log(accessToken);
        //debugger;
        var url = 'reports/getPIReportdata?gradeYear=' + grade;
        if (tenantIdent !== undefined) {


            url = 'reports/getGradeLeveldata?gradeYear=' + grade + '&tenantCode=' + tenantIdent;
        }



        var result = await fetch(url,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
                // withCredentials: true,
                // credentials: 'include',
                // headers: {
                //     'Authorization': bearer,
                //     'Content-Type': 'application/json'
                // }
            }
        ).then(data => data.json()).then(
            (data) => {
                return (data);
            },
            (error) => {
                // setLoading(false);
                //setError(error);
            }
        );
        return result;
    }

    function handleGradeChange(event, data) {

        setIsLoading(true);
        var selectedValue = event.target.value;
        var index = event.nativeEvent.target.selectedIndex;
        var selectedGradeName = event.nativeEvent.target[index].text;



        FetchReportData(event.target.value, accessToken).then((reportData) => {
            //console.log(reportData);
            setIsLoading(false);
            setSelectedGrade(selectedValue);
            setSelectedGradeName(selectedGradeName);
            setReportData(reportData);
            setReportDescription('This report outlines the personal information (PI) that ' + reportData.tenantName + ' has shared with application vendors in order to support the student learning experience. All the vendors listed below have been through a Privacy Impact Assessment (PIA) before any student personal information was shared with them.  The school\'s process for evaluating and using software complies with provincial and federal regulatory requirements. Only the minimum and necessary PI is shared with vendors, the PI is only used for the purposes for which it is collected and there are processes in place for personal information to be secured and removed from these vendors when the appliation is no longer required to support the student. This report does not include personal information that has been gathered about a student through the admissions and re-registration processes.  It does not include personal information that has been gathered or created as part of the student\'s education at the school such as (but not limited to):  student assessment and evaluation and student support data. The sharing of this personal information is governed by the provincial/state bodies through their particular education legislation. For questions about this report, please contact ' + reportData.poname + '.');
        });

    };

    function joinValues(arrayToJoin) {
        if (arrayToJoin !== null) {
            return arrayToJoin.join(', ');
        }
        return '';
    }



    return (

        <Fragment>
            <Grid style={{ width: '100%' }} container spacing={3}>
                <Grid item xs={8}>
                    <Typography align="center" variant="h5" component="h2">
                        Personal Information Sharing Report for Parents
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <InputLabel>Select student grade level from drop down below:</InputLabel>
                    <NativeSelect value={selectedGrade} onChange={(e) => handleGradeChange(e, gradeList)}>
                        <option disabled value="0">
                            Select Grade
                        </option>
                        {gradeList.map((item) => (
                            <option key={item.lookupItemId} value={item.lookupItemId}>
                                {item.name}
                            </option>
                        ))}
                    </NativeSelect>
                </Grid>
                <Grid item xs={4}>
                    {selectedGrade !== '0' &&

                        // <div paddingLeft={2}>
                        <Button variant="outlined" onClick={Print}>Print</Button>
                        // </div>
                    }
                </Grid>
            </Grid>
            {selectedGrade !== '0' &&
                <div id='printablediv'>

                    <Grid style={{ width: '100%' }} container spacing={3}>

                        <Grid item xs={12}>
                            <Box
                                component="img"
                                paddingTop={1}
                                sx={{
                                    height: 64,
                                    //maxWidth:100,
                                }}
                                alt="Your logo."
                                src={"../images/" + reportData.logofile}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography align="center" variant="h5" component="h2">
                                Personal Information Sharing Report for Parents
                            </Typography>
                            <Typography align="center">
                                Date Created: {new Date().toLocaleString() + ''}
                            </Typography>
                        </Grid>
                        <Grid item xs={2} />
                        <Grid item xs={2} >

                        </Grid>
                        <Grid item xs={12}>
                            <Typography >
                                {/* This report outlines the personal information (PI) that {data.tennantName} has shared with application vendors in order to support the sudent learning experience. All the vendors listed below have been through a Privacy Impact Assessment (PIA) before any student personal information was shared with them.  The school's process for evaluating and using software complies with provincial and federal regulatory requirements. Only the minimum and necessary PI is shared with vendors, the PI is only used for the purposes for which it is collected and there are processes in place for personal information to be secured and removed from these vendors when the appliation is no longer required to support the student. This report does not include personal information that has been gathered about a student through the admissions and re-registration processes.  It does not include personal information that has been gathered or created as part of the student's education at the school such as (but not limited to):  student assessment and evaluation and student support data. The sharing of this personal information is governed by the provincial/state bodies through their particular education legislation. For questions about this report, please contact {data.tennantPrivacyOfficer} */}
                                {reportDescription}
                            </Typography>

                        </Grid>

                        <Fragment>

                            <Grid item xs={12} >
                                <Typography align="center">
                                    Grade Selected: {selectedGradeName}
                                </Typography>
                            </Grid>

                            <Grid item xs={12} >
                                <Table size="small">
                                    <colgroup>
                                        <col width="10%" />
                                        <col width="10%" />
                                        <col width="60%" />
                                        <col width="10%" />
                                        <col width="10%" />
                                    </colgroup>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Application Name</TableCell>
                                            <TableCell>URL</TableCell>
                                            <TableCell >Description</TableCell>
                                            <TableCell>Student Information</TableCell>
                                            <TableCell>Privacy Policy</TableCell>
                                            {/* <TableCell>Notes</TableCell> */}
                                        </TableRow>
                                    </TableHead>
                                    {!(typeof reportData === 'undefined') &&
                                        <TableBody>
                                            {reportData.pias.map((row) => (
                                                <TableRow key={row.id}>
                                                    <TableCell>{row.name}</TableCell>
                                                    <TableCell>{row.url}</TableCell>
                                                    <TableCell >{row.description}</TableCell>
                                                    <TableCell>{joinValues(row.studentInfoSelected)}</TableCell>
                                                    <TableCell><a href={row.privacyPolicyUrl} target="_blank">{row.privacyPolicyUrl}</a></TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>}
                                </Table>
                            </Grid>
                        </Fragment>


                    </Grid >
                    <Grid item xs={12} />



                </div>}



        </Fragment>




    )
}